<template>
  <IQOS required>
    <template #title>
      <div v-if="!editing">
        {{ section.name || "#" + (index + 1) }}
      </div>

      <div v-else>
        <BaseInput class="hall-name-input" v-model="edit_object.name" />
      </div>
    </template>

    <div class="section-tables-list mt-16">
      <div
        class="section-table"
        v-for="(table, idx) in edit_object.tables_list"
        :key="idx"
      >
        <div class="table-image-block">
          <img :src="table.image || '/icons/table-placeholder.png'" class="table-image" />
          <div class="table-image-actions mt-8" v-if="editing">
            <ImageUploader type="cafe" @success="e => onImageUploaded(table, e)" class="w-100">
              <BaseButton 
                variant="secondary" 
                icon="camera" 
                color="v1-grey-10" 
                class="w-100"
                size="md"/>
            </ImageUploader>
            <BaseButton 
              class="ml-4 w-100"
              variant="secondary" 
              icon="pencil" 
              color="v1-grey-10" 
              size="md"
              v-if="table.image"/>
            <BaseButton 
              class="ml-4 w-100"
              variant="secondary" 
              icon="trash" 
              color="v1-grey-10" 
              size="md"
               v-if="table.image"
              @click="table.image = null"/>
          </div>
        </div>
        <div class="table-info">
          <BaseInput
            align="center"
            position="center"
            fullWidth
            disabled
            :value="`№ ${idx + 1}`"
          />
          <BaseInput 
            :disabled="!editing" 
            fullWidth 
            class="mt-4" 
            :placeholder="$t('halls_tables.name_ph')"
            v-model="table.name" />
          <BaseInput
            fullWidth
            :disabled="!editing"
            type="number"
            :placeholder="$t('halls_tables.places_ph')"
            class="mt-4"
            v-model.number="table.places_count"
          />
          <BaseButton
            variant="secondary"
            v-if="editing"
            @click="removeTable(idx)"
            size="md"
            color="red-4"
            icon="trash"
            class="w-100 mt-8"
          >
            {{ $t("halls_tables.delete_btn") }}
          </BaseButton>
        </div>
      </div>
    </div>

    <div class="add-container mt-16" v-if="editing">
      <BaseButton
        class="add-btn"
        size="lg"
        variant="secondary"
        @click="addTable"
        color="v1-grey-7"
        icon="plus"
        >
        {{ $t("halls_tables.add_btn") }}
      </BaseButton>
    </div>

    <template #actions>
      <BaseButton
        variant="secondary"
        color="red-4"
        size="md"
        icon="trash"
        class="mr-16"
        @click="deleting = true"
        v-if="editing"
      >
        {{ $t("halls_tables.remove_hall") }}
      </BaseButton>

      <IQOSActions
        size="md"
        :editing="editing"
        @edit="showEditUI"
        @accept="onEditFinish"
      />
    </template>

    <DangerConfirmModal
      @confirm="deleteHall"
      @cancel="deleting = false"
      v-if="deleting">
      {{ $t('halls_tables.confirm_remove_hall') }}
    </DangerConfirmModal>
  </IQOS>
</template>

<script>
import ImageUploader from "@/components/ImageUploader.vue"

export default {
  data() {
    return {
      editing: false,

      edit_object: {},

      deleting: false
    };
  },
  components: {
    ImageUploader
  },
  props: {
    index: Number,
  },
  methods: {
    onEditFinish() {
      this.editing = false;

      this.$store.commit('setCafeSection', {
        index: this.index,
        value: this.edit_object
      });

      this.$store.dispatch('saveCafe');

      this.$store.dispatch("auditlog/write", {
        type: "change_cafe_section",
        payload: {
          name: this.section.name,
          index: this.index,
          tables_list: this.section.tables_list
        },
      });
    },
    reset() {
      this.edit_object = Object.assign({}, this.section);
    },
    showEditUI() {
      this.reset();
      this.editing = true;
    },
    removeTable(idx) {
      this.edit_object.tables_list.splice(idx, 1);
    },
    addTable() {
      this.edit_object.tables_list.push({
        name: null,
        places_count: null,
        for_reserve: false,
        x_pos: 5,
        y_pos: 5,
        width: 4,
        height: 4
      });
    },
    onImageUploaded(table, sizes) {
      this.$set(table, 'image', sizes.md);
    },
    deleteHall() {
      const name = this.section.name || this.index;
      const tables_count = this.section.tables_list.length;

      this.deleting = false;

      this.$store.commit('removeCafeSection', {
        index: this.index
      });

      this.$store.dispatch('saveCafe');

      this.$store.dispatch("auditlog/write", {
        type: "delete_cafe_section",
        payload: {
          name,
          index: this.index,
          tables_count
        },
      });
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    section() {
      return this.cafe.sections[this.index];
    },
  },
};
</script>

<style scoped>
.section-tables-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  column-gap: 8px;
  row-gap: 16px;
}

.section-table {
  display: flex;

  flex: 0 0 calc(50% - 16px);

  background: var(--v1-grey-3-color);
  padding: 4px;
  border-radius: 4px;
}

.table-image-block {
  width: fit-content;
  margin-right: 16px;
}

.table-image-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.table-info {
  width: 100%;
}

.table-image {
  width: 200px;
  height: 104px;
  max-width: 200px;
  min-height: 104px;
  min-width: 200px;
  display: block;
  border-radius: 4px;
}

.add-container {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}

.add-btn {
  width: 33% !important;
}

.hall-name-input {
  width: 450px;
}
</style>